// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogWrapper[data-v-e18bf788] .el-dialog__body {\n  padding: 0px 20px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
